import React, { useEffect, useState } from 'react';
import {
  StyledAvatar,
  StyledImage,
  StyledWrapper,
  StyledInitialsUser,
  StyledGreeting,
  StyledFullName,
  StyledDepartment
} from './style';
import OracleHCMBackground from '../../../../assets/images/png/FondoA3MIA_Widget.png';
import { API, API_SOCIAL } from '../../../constants/api';
import request from '../../../utils/api';
import { getUser } from '../../../utils/apiUser';
import { getCropWithPath } from '../../../utils/crops';
import { getEmployeeList } from '../../../utils/apiMiniWidget';

const OracleHCM = () => {
  const [link, setLink] = useState('');
  const [avatar, setAvatar] = useState('');
  const [fullName, setFullName] = useState('');
  const [departmentName, setDepartmentName] = useState('');
  const [isImage, setIsImage] = useState(false);
  const [name, setName] = useState('');
  const [lastname, setLastname] = useState('');

  async function isPhotoLoad(url) {
    if (!url) {
      return false;
    }
    const response = await request(url, { method: 'GET' }, false);
    return response.status === 200;
  }

  const getGreeting = () => {
    const date = new Date();
    const hour = date.getHours();

    if (hour < 14) {
      return 'Buenos días';
    }
    if (hour < 20) {
      return 'Buenas tardes';
    }
    return 'Buenas noches';
  };

  const getImageURL = params =>
    request(`${API_SOCIAL}widget/home`, {
      params,
      method: 'GET'
    }).then(response => {
      response.map(el => {
        if (el.type === 'oraclehcm') {
          setLink(el.url);
        }
        return link;
      });
    });

  useEffect(() => {
    try {
      getUser().then(response => {
        setName(response.name);
        setLastname(response.lastname);
        setAvatar(`${API}${getCropWithPath({ idUser: response.userId })}`);
        isPhotoLoad(
          `${API}${getCropWithPath({ idUser: response.userId })}`
        ).then(res => {
          setIsImage(res);
        });
        const firstName =
          response.name.split(' ').length > 1
            ? response.name.split(' ')[0]
            : response.name;
        const lastName =
          response.lastname.split(' ').length > 1
            ? response.lastname.split(' ')[0]
            : response.lastname;
        const fullNameFormConect = `${firstName} ${lastName}`;

        getEmployeeList({ employeeId: response.employeeId }).then(response => {
          setDepartmentName(response.content[0]?.department);
          const fullName = response.content[0]?.knowAs
            ? response.content[0]?.knowAs
            : fullNameFormConect;
          setFullName(fullName);
        });
      });
      getImageURL();
    } catch (error) {
      console.error(error);
    }
  }, []);

  return (
    <StyledWrapper id="a3mia">
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'block',
          maxHeight: '340px'
        }}
        id="a3miaLink"
      >
        <StyledImage src={OracleHCMBackground} />
        {isImage ? (
          <StyledAvatar alt="Foto de perfil" src={avatar} />
        ) : (
          <StyledInitialsUser>
            {`${name.charAt(0)}${lastname.charAt(0)}`}
          </StyledInitialsUser>
        )}
        <StyledGreeting isImage={isImage}>{getGreeting()}</StyledGreeting>
        <StyledFullName isImage={isImage}>{fullName}</StyledFullName>
        <StyledDepartment isImage={isImage}>{departmentName}</StyledDepartment>
      </a>
    </StyledWrapper>
  );
};

export default OracleHCM;
